import { useMemo } from 'react'
import { faBank } from '@fortawesome/pro-regular-svg-icons'
import { institutionLogoMap } from '@/src/constants/logoConstants'
import { PlaidItem } from '@/reducers/finances/plaidItemReducer'
import { inOperator } from '@/utils/typeHelpers'
import { Icon, Image } from '@/ui'

interface InstitutionLogoProps {
  institution: PlaidItem
  className?: string
  width?: number
}

export const InstitutionLogo = ({
  institution,
  className,
  width = 48,
}: InstitutionLogoProps) => {
  const { logo, institutionName } = institution

  const src = useMemo(() => {
    if (logo) return `data:image/png;base64, ${logo}`

    if (inOperator(institutionName, institutionLogoMap)) {
      return institutionLogoMap[institutionName]
    }

    return undefined
  }, [institutionName, logo])

  if (src) {
    return (
      <Image
        src={src}
        alt={`${institution.institutionName} logo`}
        width={width}
      />
    )
  }

  return (
    <div className={className}>
      <Icon icon={faBank} size="lg" color="white" />
    </div>
  )
}
